export default {"src":"/_next/static/media/bg-table-contents.56e173eb.svg","height":123,"width":48,"blurWidth":0,"blurHeight":0};